import { Drawer2 } from "@/frontend/shared/ui/Drawer2";
import { Comments, TCommentsProps } from "../Comments";
import styles from "./CommentsDrawer.module.scss";
import clsx from "clsx";
type TCommentsDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  position: "left" | "right" | "bottom";
} & TCommentsProps;

export function CommentsDrawer({ isOpen, onClose, position, ...props }: TCommentsDrawerProps) {
  return (
    <Drawer2
      isOpen={isOpen}
      onClose={onClose}
      position={position}
      title="Comments"
      className={clsx(styles.drawer, position === "bottom" && styles.bottom)}
    >
      <Comments {...props} showTitle={false} className={styles.comments} />
    </Drawer2>
  );
}
